import { useTranslation } from 'react-i18next';

import ClientQuotesCardSkeleton from './components/ClientQuotesCardSkeleton/ClientQuotesCardSkeleton';
import ExpandableCard from '../../../../../../shared/components/Cards/ExpandableCard/ExpandableCard';
import type { IQuoteFlowReturnTarget } from '../../../../../../shared/hooks/useQuoteActions/useQuoteActions';
import type { IProspect } from '../../../../../../shared/interfaces/prospects';
import type { IQuote } from '../../../../../../shared/interfaces/quotes';
import { TRANSLATIONS_CLIENTS } from '../../../../../../shared/translations/clients';
import { ClientsStatus } from '../../../../../../shared/types/clients';
import QuotedCard from '../../../../../Prospects/sections/ProspectProfile/sections/QuotesCard/QuotedCard';

interface IClientQuotesCardProps {
  status: ClientsStatus;
  prospect: IProspect | null;
  quotes: IQuote[];
  loading: boolean;
  onQuoteStatusChange: () => void;
  returnTo: IQuoteFlowReturnTarget;
}

const ClientQuotesCard = ({
  status,
  prospect,
  quotes,
  loading,
  onQuoteStatusChange,
  returnTo
}: IClientQuotesCardProps) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <ExpandableCard className="quoted-card" title={t(TRANSLATIONS_CLIENTS.profile.sections.quotes)}>
        <ClientQuotesCardSkeleton />
      </ExpandableCard>
    );
  }

  if (!prospect) return null;

  const quotesFiltered = quotes.filter((quote) => quote.status == 'created');
  const acceptDisabledTooltip =
    status === ClientsStatus.AwaitingStart ? t(TRANSLATIONS_CLIENTS.profile.quotes.acceptDisabledTooltip) : undefined;

  return (
    <QuotedCard
      showTrailingComponent={false}
      prospect={prospect}
      quotes={quotesFiltered}
      titleKey={TRANSLATIONS_CLIENTS.profile.sections.quotes}
      showNewQuote={true}
      emptyTextKey={TRANSLATIONS_CLIENTS.profile.quotes.empty}
      onQuoteStatusChange={onQuoteStatusChange}
      returnTo={returnTo}
      fromClientProfile
      acceptDisabledTooltip={acceptDisabledTooltip}
    />
  );
};

export default ClientQuotesCard;
